<template>
  <div class="fill-height">
    <FufuHeader :shop="null"> 予約完了 </FufuHeader>
    <v-container class="white" fill-height fluid>
      <v-layout column>
        <v-flex>
          <v-layout justify-center align-center fill-height>
            <span class="subtitle-1">
              <b>ご予約ありがとうございました。</b>
            </span>
          </v-layout>
        </v-flex>

        <v-flex v-if="result">
          <v-card outlined>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> ご予約店舗 </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                {{ result.shopName }}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> メニュー </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                <v-layout column>
                  <span>
                    {{ result.menuDisplayName }}
                  </span>
                  <span v-if="result.colorName">
                    {{ result.colorName }}
                  </span>
                  <span v-if="result.treatmentName">
                    {{ result.treatmentName }}
                  </span>
                  <span v-if="result.scalpCareName">
                    {{ result.scalpCareName }}
                  </span>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> ご予約日時 </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                {{ datetime(result.start) }}
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                xs4
                class="primary--text text-center pa-3"
                style="background-color: #f5f5f5"
              >
                <b> お客さま情報 </b>
              </v-flex>
              <v-flex xs8 class="py-3 pl-5">
                <span>
                  {{ result.familyNameKana }}
                  {{ result.givenNameKana }}
                  様
                </span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex class="text-center">
          ご予約はアプリが便利♪さっと予約ができたり、新店情報が届いたり、と便利がいっぱい。
          <br />
          ぜひ、fufuアプリをご活用下さい。
        </v-flex>
        <v-flex>
          <v-layout>
            <v-flex xs3 offset-xs3>
              <v-layout column align-center>
                iPhoneはこちら
                <v-img
                  :src="`${$publicPath}img/qr-app-ios-196.png`"
                  width="196"
                  height="196"
                />
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <v-layout column align-center>
                androidはこちら
                <v-img
                  :src="`${$publicPath}img/qr-app-android-205.png`"
                  width="196"
                  height="196"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex class="text-center">
          <v-btn text color="primary" large replace @click="goTop">
            <v-icon>mdi-chevron-right</v-icon>
            <b>トップページへ戻る</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import FufuHeader from '@/components/FufuHeader'

export default {
  name: 'DoneView',
  components: {
    FufuHeader,
  },
  props: {
    firstVisitor: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    timerId: null,
  }),
  computed: {
    result() {
      const txt = this.$route.query.result
      try {
        if (txt) {
          return JSON.parse(txt)
        }
      } catch (err) {
        console.error(err)
      }
      return null
    },
  },
  mounted() {
    this.timerId = setTimeout(() => {
      this.goTop()
    }, 60000)
  },
  beforeDestroy() {
    if (this.timerId) clearTimeout(this.timerId)
  },
  methods: {
    goTop() {
      const shopId = this.$route.query.shop
      if (this.mode === 2 && shopId) {
        this.$router.replace({
          name: 'ReservationTop',
          params: { shopId },
        })
      } else {
        this.$router.replace({
          path: '/',
        })
      }
    },
    datetime(value) {
      if (!value) return value
      return moment(value).format('YYYY/MM/DD HH:mm')
    },
  },
}
</script>

<style></style>
